import native from './native';

export default process.env.REACT_APP_PLATFORM || process.env.STORYBOOK_PLATFORM || native;
